import React from 'react';
import {
  AWAITING_ACCEPTANCE,
  CANCELED,
  FINISHED,
  IN_CONSTRUCTION,
  IN_ESTIMATION,
  NOW_ACCEPTING,
  OWN_AWAITING_ACCEPTANCE,
  OWN_FINISHED,
  OWN_IN_CONSTRUCTION,
  OWN_IN_ESTIMATION,
  OWN_SEND_ESTIMATE,
  PARTIALLY_FINISHED,
  SEND_ESTIMATE
} from '~/models/Status';
import { InEstimation } from '~/components/specifics/deals/[id]/statuses/InEstimation';
import { SendEstimate } from '~/components/specifics/deals/[id]/statuses/SendEstimate';
import { InConstruction } from '~/components/specifics/deals/[id]/statuses/InConstruction';
import { AwaitingAcceptance } from '~/components/specifics/deals/[id]/statuses/AwaitingAcceptance';
import { Finished } from '~/components/specifics/deals/[id]/statuses/Finished';
import { Canceled } from '~/components/specifics/deals/[id]/statuses/Canceled';
import { NowAccepting } from '~/components/specifics/deals/[id]/statuses/NowAccepting';
import { OwnInEstimation } from '~/components/specifics/deals/[id]/statuses/OwnInEstimation';
import { OwnInConstruction } from '~/components/specifics/deals/[id]/statuses/OwnInConstruction';
import { OwnFinished } from '~/components/specifics/deals/[id]/statuses/OwnFinished';
import { PartiallyFinished } from '~/components/specifics/deals/[id]/statuses/PartiallyFinished';
import { OwnSendEstimate } from './OwnSendEstimate';
import { OwnAwaitingAcceptance } from './OwnAwaitingAcceptance';

type Props = {
  statusId: number;
};
type ComponentsType = {
  [key: number]: React.FC;
};

export const StatusSwitcher: React.FC<Props> = ({ statusId }: Props) => {
  const Components: ComponentsType = {
    [NOW_ACCEPTING]: NowAccepting,
    [IN_ESTIMATION]: InEstimation,
    [SEND_ESTIMATE]: SendEstimate,
    [IN_CONSTRUCTION]: InConstruction,
    [AWAITING_ACCEPTANCE]: AwaitingAcceptance,
    [PARTIALLY_FINISHED]: PartiallyFinished,
    [FINISHED]: Finished,
    [OWN_IN_ESTIMATION]: OwnInEstimation,
    [OWN_SEND_ESTIMATE]: OwnSendEstimate,
    [OWN_IN_CONSTRUCTION]: OwnInConstruction,
    [OWN_AWAITING_ACCEPTANCE]: OwnAwaitingAcceptance,
    [OWN_FINISHED]: OwnFinished,
    [CANCELED]: Canceled
  };
  const Component = Components[statusId] ?? null;
  if (Component === null) {
    throw new Error(`Invalid deal status. statusId: ${statusId}`);
  }
  return <Component />;
};
